module.exports = __webpack_public_path__ + "static/media/home-delivery.c431cb38.jpg";